var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 11,
    viewBox: "0 0 14 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.41406 4.04069L0.706955 4.7478L-0.000151504 4.04069L0.706955 3.33358L1.41406 4.04069ZM13.0807 9.37402C13.0807 9.92631 12.633 10.374 12.0807 10.374C11.5284 10.374 11.0807 9.92631 11.0807 9.37402L12.0807 9.37402L13.0807 9.37402ZM4.7474 7.37402L4.04029 8.08113L0.706955 4.7478L1.41406 4.04069L2.12117 3.33358L5.4545 6.66692L4.7474 7.37402ZM1.41406 4.04069L0.706955 3.33358L4.04029 0.000249633L4.7474 0.707356L5.4545 1.41446L2.12117 4.7478L1.41406 4.04069ZM1.41406 4.04069L1.41406 3.04069L6.74739 3.04069L6.74739 4.04069L6.74739 5.04069L1.41406 5.04069L1.41406 4.04069ZM6.74739 4.04069L6.74739 3.04069C10.2452 3.04069 13.0807 5.87622 13.0807 9.37402L12.0807 9.37402L11.0807 9.37402C11.0807 6.98079 9.14063 5.04069 6.74739 5.04069L6.74739 4.04069Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.4b29cf5eef9087c9cb2c82e40e0b9389.svg";
export { ForwardRef as ReactComponent };